<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1C03QXm/tc-custom/9781936535460.jpg?1718282808968" alt="This image is the cover for the book Son of the Hero, The Varayan Memoir"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Son of the Hero, The Varayan Memoir
      </h1>
      <p class="bookDescription body article font2">
        <p>Gil Tyner has plans for the future: he’s going to be a computer programmer in the bustling technology Mecca of Silicon Valley. And as his 21st birthday approaches, he’s on the cusp of realizing his goals.<br/><br/>But fate has other plans. A note from his mother on his birthday propels Gil into The Buffer Zone, seven magical kingdoms that stand between our world and the realm of the immortal elves.<br/><br/>Gil’s about to learn that plans can change. When destiny calls, he’ll discover that the life he’d imagined and the life he’ll lead will be very different.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick Shelley
      </h2>
      
      <p class="authorDescription body article">Rick Shelley (January 1, 1947 - January 27, 2001) was a military science fiction author. In addition to a plethora of short fiction, he also wrote the Dirigent Mercenary Corps, Spec Ops Squad, Federation War, 13 Spaceborn, Seven Towers, and Varayan Memoir series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8d213604